import { useEffect, useState } from 'react';
import api from '../services/api';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { CalendarDays, Clock, MapPinned, UserRound } from 'lucide-react';
import { toast } from 'sonner';

const todayInput = () => new Date().toISOString().slice(0, 10);

const MyDayPage = () => {
  const [date, setDate] = useState(todayInput());
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVisits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const loadVisits = async () => {
    try {
      setLoading(true);
      const response = await api.getMyDayVisits(date);
      setVisits(response.visits || []);
    } catch (error) {
      toast.error('Erro ao carregar MeuDia');
      setVisits([]);
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (value) => new Date(value).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="space-y-6" data-testid="my-day-page">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">MeuDia</h1>
          <p className="text-muted-foreground mt-1">Visitas do vendedor itinerante para o dia selecionado</p>
        </div>
        <div className="flex items-center gap-2">
          <Input type="date" value={date} onChange={(event) => setDate(event.target.value)} className="w-44" />
          <Button variant="outline" onClick={() => setDate(todayInput())}>
            Hoje
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="flex h-64 items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary" />
        </div>
      ) : visits.length === 0 ? (
        <Card className="border-dashed">
          <CardContent className="flex flex-col items-center justify-center py-12">
            <CalendarDays className="mb-4 h-12 w-12 text-muted-foreground" />
            <p className="text-muted-foreground">Nenhuma visita encontrada para este dia.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {visits.map((visit) => (
            <Card key={visit.id}>
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between gap-3">
                  <CardTitle className="text-lg">{visit.title}</CardTitle>
                  <Badge variant="outline">{visit.taskType}</Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex items-center gap-2 text-sm">
                  <Clock className="h-4 w-4 text-muted-foreground" />
                  {formatTime(visit.startAt)} - {formatTime(visit.endAt)}
                </div>
                {visit.customer && (
                  <div className="flex items-center gap-2 text-sm">
                    <UserRound className="h-4 w-4 text-muted-foreground" />
                    <span>{visit.customer.name}</span>
                  </div>
                )}
                {visit.territory && (
                  <div className="flex items-center gap-2 text-sm">
                    <MapPinned className="h-4 w-4 text-muted-foreground" />
                    <span>{visit.territory.code} - {visit.territory.name}</span>
                  </div>
                )}
                {visit.detail && <p className="text-sm text-muted-foreground">{visit.detail}</p>}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyDayPage;
